import getAxisValue from "./get-axis-value";
import getDelta from "./get-delta";

/**
 * Delta "absolute" both percents
 * @param {MainClassProps} _main
 * @param {TriggerProps} trigger
 * @returns
 */
const getDeltaContinuous = (_main, trigger) => {
  const axis = getAxisValue(trigger);

  switch (axis) {
    case "x":
      return getDelta(trigger, "x");

    case "y":
      return getDelta(trigger, "y");

    default:
      const x = getDelta(trigger, "x");
      const y = getDelta(trigger, "y");
      return (x + y) / 2;
  }
};

export default getDeltaContinuous;
